/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { SignalConnectionLoader } from '../../components/loaders/SignalConnectionLoader';
import { ProjectsView } from './ProjectsView';

export const ProjectsLoader = () => {
    return (
        <SignalConnectionLoader>
            <ProjectsView />
        </SignalConnectionLoader>
    );
};
